import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
// 解决Promise在IE下未定义的问题
import promise from 'es6-promise'
import store from './vuex'

Vue.prototype.qs = qs
promise.polyfill()

// 配置axios请求
var axiosInstance = axios.create({
  timeout: 10000,
  baseURL: sessionStorage.baseURL
})
axiosInstance.interceptors.request.use(function (config) {
  if(config.setting && config.setting.timeout) {
    config.timeout = config.setting.timeout
  }
  if(sessionStorage.token) {
    config.headers.token = sessionStorage.token
  }
  if("get" == config.method.toLowerCase()) {
		if(config.params) {
			config.params.timestamp = new Date().getTime()
		} else {
			config.params = {
				timestamp: new Date().getTime()
			}
		}
	}
  return config
}, function (error) {
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use(function (response) {
  var config = response.config
  var status = response.data.status
  if(status === '200' || status === '203') {
    return response.data
  } else if (status === '402' || status === '401') {
    Vue.$vux.toast.hide()
    Vue.$vux.toast.text(response.data.msg)
    // alert(response.config.url)
    sessionStorage.removeItem("token")
    store.state.APPPAGE.toLoginFunc()
    return Promise.reject(response.data.msg)
  } else {
    if(!config.setting || !config.setting.hiddenMessage) { Vue.$vux.toast.text(response.data.msg) }
    return response.data
  }
}, function (error) {
  var errorMsg = '', errorCode = null;
	if(error.message.includes('timeout')){
		errorMsg = '请求超时，请检查网络或联系系统管理员'
		errorCode = 408
	} else {
		errorMsg = '请求异常，请检查网络或联系系统管理员'
		errorCode = 503
  }
  Vue.$vux.toast.hide()
  Vue.$vux.toast.text(errorMsg)
  var logInfo = {
		errorCode: errorCode,
		errorMsg: errorMsg,
		requestUrl: error.config.url
	}
	// Vue.prototype.$LonbonLog("请求问题", JSON.stringify(logInfo));
	return Promise.reject(logInfo)
})
Vue.prototype.$axios = axiosInstance






// WEBPACK FOOTER //
// ./src/config/axios.js